<template>
    <div class="prepay-detail">
        <h3>职位详情</h3>
        <el-form :model="jobInfo" :rules="rules" ref="jobInfo" class="demo-form-inline" size="mini" label-width="180px">
            <el-form-item label="职位标题" prop="title">
                <el-input type="text" v-model="jobInfo.title"></el-input>
            </el-form-item>
            <el-form-item label="职位详情" prop="description">
                <el-input type="textarea" rows="10" v-model="jobInfo.description"></el-input>
            </el-form-item>
            <el-form-item label="职位级别" prop="jobLevel">
                <el-input type="number" min="1" v-model="jobInfo.jobLevel"></el-input>
            </el-form-item>
            <!-- <el-form-item label="职位状态" prop="status">
                <el-switch v-model="jobInfo.status" inactive-text="关闭" active-text="开启" :inactive-value="0" :active-value="1">
                </el-switch>
            </el-form-item> -->
            <el-form-item label="职位类型" prop="jobCate">
                <el-select v-model="jobInfo.jobCate" value-key="id" placeholder="请选择" @change="cateChange('jobCate')">
                    <el-option v-for="item in firstCates" :key="item.id" :label="item.name" :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属职业" prop="skillTags">
                <el-select v-model="jobInfo.skillTags" :multiple="true" :multiple-limit="1" value-key="id" placeholder="请选择"  @change="cateChange('skillTags')">
                    <el-option v-for="item in secondCates" :key="item.id" :label="item.name" :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="技能标签" prop="thirdSkillTags">
                <el-select v-model="jobInfo.thirdSkillTags" :multiple="true" :multiple-limit="3" value-key="id" placeholder="请选择">   
                    <el-option-group v-for="group in jobInfo.skillTags" :key="group.id" :label="`${group.name}：`">
                        <el-option v-for="item in getCatesById(group.id)" :key="item.id" :label="item.name" :value="item">
                        </el-option>
                    </el-option-group>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="submit">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import api from '../api'

export default {
    name: "jobDetail",
    data() {
        return {
            customTags: [],
            cates: [],
            jobInfo: {
                title: '',
                jobLevel: '',
                // status: 1,
                description: '',
                jobCate: {
                    id: '',
                    name: '',
                },
                skillTags: [],
                thirdSkillTags: [],
                customTags: [],
            },
            rules: {
                title: [{
                    required: true,
                    message: '请输入职位标题',
                    trigger: 'blur'
                }, {
                    min: 3,
                    max: 30,
                    message: '长度在 3 到 30 个字符',
                    trigger: 'blur'
                }],
                jobLevel: [{
                    required: true,
                    message: '请输入职位级别',
                    trigger: 'blur'
                }],
                description: [{
                    max: 1000,
                    message: '长度最大1000 个字符',
                    trigger: 'blur'
                }],
                jobCate: [{
                    required: true,
                    message: '请选择职位类型',
                }],
                skillTags: [{
                    required: true,
                    message: '请选择所属行业',
                }],
                // thirdSkillTags: [{
                //     required: true,
                //     message: '请选择技能标签',
                // }],
            }
        };
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
        firstCates() {
            return this.getCatesById(0);
        },
        secondCates() {
            return this.getCatesById(this.jobInfo.jobCate.id);
        },
    },
    watch: {},
    mounted() {
        this.getDetail();
    },
    methods: {
        async getDetail() {
            let {
                data: {
                    code,
                    data
                }
            } = await api.job.detail({
                jobId: this.id
            })
            if (code == 200) {
                this.jobInfo = data;
                this.getAllTags();
            }
        },
        submit() {
            this.$refs.jobInfo.validate(valid => {
                if (valid) {
                    let jobInfo = this.jobInfo;
                    let skills = jobInfo.thirdSkillTags.concat(jobInfo.customTags);
                    if (skills.length) {
                        this.update();
                    } else {
                        this.$message.error('技能标签不能为空');
                    }
                    
                } else {
                    return false;
                }
            })
        },
        async update() {
            let {
                data: {
                    code
                }
            } = await api.job.update({
                jobId: this.id,
                title: this.jobInfo.title,
                jobLevel: Number(this.jobInfo.jobLevel),
                description: this.jobInfo.description,
                // status: this.jobInfo.status,
                jobCate: this.jobInfo.jobCate,
                skillTags: this.jobInfo.skillTags,
                thirdSkillTags: this.jobInfo.thirdSkillTags,
            })
            if (code == 200) {
                this.$message.success('更新职位信息成功')
            }
        },
        async getAllTags() {
            let {
                data: {
                    code,
                    data,
                }
            } = await api.workCateList.getAllTags({
                publisherIdEnc: this.jobInfo.publisherIdEnc
            })
            if (code == 200) {
                this.cates = data.workCategory;
                this.customTags = data.customTags;
            }
        },
        formatCustomTags(customTags) {
            customTags.forEach(item => {
                item.isCustom = true;
            })
            return customTags;
        },
        getCatesById(id) {
            let arr = [];
            this.cates.forEach(item => {
                if (item.parentId === id) {
                    arr.push(item);
                }
            });
            return arr;
        },
        cateChange(name) {
            switch(name) {
                case 'jobCate':
                    this.jobInfo['skillTags'] = [];
                    this.jobInfo['thirdSkillTags'] = [];
                    break;
                case 'skillTags':
                    this.delThirdCates();
                    break;
                default:
            }
        },
        inArr(id, array) {
            let isIn = false;
            array.forEach(item => {
                if (item.id === id) {
                    isIn = true;
                }
            })
            return isIn;
        },
        delThirdCates() {
            let thirdCates = this.jobInfo.thirdSkillTags;
            let newArr = [];
            thirdCates.forEach(item => {
                if (this.inArr(item.parentId, this.jobInfo.skillTags)) {
                    newArr.push(item);
                }
            })
            this.jobInfo.thirdSkillTags = newArr;
        },
    },
};
</script>
<style scoped>
.demo-form-inline {
    width: 640px;
}
</style>


// WEBPACK FOOTER //
// src/views/job/detail.vue